<template>
  <section class="custom-wrapper">
    <div class="row">
      <div class="col d-flex flex-column">
        <span class="custom-members">Challenge members:</span>
        <div class="list-group custom-list">
          <div v-if="selected.length === 0">none</div>
          <div
            v-for="item of selected"
            :key="item.id"
            class="list-group-item list-group-item-action"
          >
            <input
              type="checkbox"
              :checked="item.isSelected === 1"
              class="z-checkbox-small"
              @click="selectSelected('selected', item.id)"
            />
            <span class="ms-2">{{ setClientName(item) }}</span>
            <!-- <span class="ms-2">{{ item.isSelected }}</span> -->
          </div>
        </div>
      </div>
      <div class="col-md-auto custom-arrow-buttons-wrapper">
        <div class="custom-arrow-buttons">
          <button
            class="btn btn-sm btn-outline-secondary"
            v-show="showLeftArrowButton"
            title="add member(s)"
            @click="addClient(false)"
          >
            <i class="fas fa-angle-left"></i>
          </button>
          <button
            class="btn btn-sm btn-outline-secondary mt-1"
            v-show="showRightArrowButton"
            title="remove member(s)"
            @click="removeClient"
          >
            <i class="fas fa-angle-right"></i>
          </button>
        </div>
      </div>
      <div class="col d-flex flex-column">
        <div class="row">
          <div class="col-md-12">
            <div class="input-group">
              <span class="input-group-text">select using client list</span>
              <select class="form-select" v-model="currentList">
                <option v-for="list of lists" :value="list.id" :key="list.id">
                  {{ list.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <span>or from members listed below:</span>
            <div class="list-group custom-list">
              <div
                v-for="item of clients"
                :key="item.user_id"
                class="list-group-item list-group-item-action"
              >
                <input
                  type="checkbox"
                  :checked="item.isSelected === 1"
                  class="z-checkbox-small"
                  @click="selectSelected('client', item.user_id)"
                />
                <span class="ms-2">{{ setClientName(item) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'challenge-members',
  data() {
    return {
      listName: '',
    }
  },
  emits: ['saveIt'],
  mounted() {
    this.init()
  },
  computed: {
    ...mapGetters('challenges', ['challenge']),
    ...mapGetters('usercardio', ['clients', 'lists', 'selected']),
    currentList: {
      get() {
        let _data = null
        return _data
      },
      set(value) {
        this.selectMembers(value)
      },
    },
    listClients() {
      let _clients = []
      let found = this.clients.find((x) => x.name === this.listName)
      if (found) {
        _clients = found.clients
      }
      return _clients
    },
    showLeftArrowButton() {
      let _show = false
      _show = this.clients.some((x) => {
        return x.isSelected === 1
      })
      return _show
    },
    showRightArrowButton() {
      let _show = false
      _show = this.selected.some((x) => {
        return x.isSelected === 1
      })
      return _show
    },
  },
  methods: {
    ...mapActions('usercardio', ['setList', 'saveList']),
    init() {
      // init the selected (changing Challenges from main listing)
      let data = {
        name: `init-selected`,
        value: null,
        listName: null,
      }
      this.setList(data)
      // if we have a Challenge and it has members,
      // we need to select them
      if (this.challenge) {
        if (this.challenge.members) {
          this.challenge.members.forEach((item) => {
            this.selectSelected('client', item.user_id)
          })
          this.addClient(true)
        }
      }
      // turn off any checkboxes
      this.resetLists()
    },
    resetLists() {
      // turn off any checkboxes
      this.resetList('client')
      this.resetList('selected')
    },
    setClientName(item) {
      let name = ''
      if (item.nickname !== '') {
        name = `${item.lastname}, ${item.firstname} (${item.nickname})`
      } else {
        name = `${item.lastname}, ${item.firstname}`
      }
      return name
    },
    selectMembers(id) {
      // user selected a user-defined Client List,
      // pull and select the members based on that
      let found = this.lists.find((x) => x.id === id)
      if (found) {
        this.list = found
        this.listName = this.list.name
        this.resetList('client')
        found.clients.forEach((item) => {
          this.selectSelected('client', item.id)
        })
        // window.app.$forceUpdate()
      }
    },
    addClient(dontSave) {
      // add the client members to the
      // selected list of members
      this.highlightSave = true
      let data = {
        name: 'addSelected',
        value: null,
        listName: this.listName,
      }
      this.setList(data)
      this.resetLists()
      if (!dontSave) {
        this.saveIt()
      }
    },
    removeClient() {
      // remove checked members (from the selected list)
      this.highlightSave = true
      let data = {
        name: 'removeSelected',
        value: null,
        listName: this.listName,
      }
      this.setList(data)
      this.saveIt()
    },
    resetList(list) {
      // reset (uncheck) the appropriate list
      let data = {
        name: `reset-${list}`,
        value: null,
        listName: this.list ? this.list.name : null,
      }
      this.setList(data)
    },
    selectSelected(list, id) {
      // set (check) the appropriate list item
      let data = {
        name: `select-${list}`,
        value: id,
        listName: this.list ? this.list.name : null,
      }
      this.setList(data)
    },
    saveIt() {
      // turn on the save buttons
      this.$emit('saveIt')
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-buttons {
  position: relative;
  float: right;
}
.form-select:focus {
  outline: none !important;
  box-shadow: none !important;
}
.custom-list {
  max-height: 350px;
  overflow-x: hidden;
  overflow-y: scroll;
}
.custom-arrow-buttons-wrapper {
  padding: 0;
}
.custom-arrow-buttons {
  width: 30px;
  text-align: center;
  top: 62px;
  position: relative;
  button {
    font-size: 1.2em;
  }
}
.custom-list-name {
  min-width: 100px;
}
.custom-list-wrapper {
  min-height: 350px;
}
.custom-members {
  font-weight: 500;
}
</style>
